// extracted by mini-css-extract-plugin
export var animationAbsolute = "_2t-q";
export var animationRelative = "_2t-p";
export var backdropBlur = "_2t-0";
export var detailLabelCell = "_2t-12";
export var detailTable = "_2t-11";
export var detailValueCell = "_2t-13";
export var docIconBox = "_2t-1d";
export var docIconBoxMd = "_2t-1f";
export var docIconBoxSm = "_2t-1e";
export var docTypeRow = "_2t-16";
export var docTypeRowInner = "_2t-17";
export var dropdownMatchDatePicker = "_2t-3";
export var evidenceCardContent = "_2t-1c";
export var fileUploadSpin = "_2t-j";
export var gorgiasOpenButton = "_2t-15 _2t-d";
export var gorgiasTicketCard = "_2t-14";
export var heroModalFooterButton = "_2t-18";
export var hiddenContainer = "_2t-o";
export var iconPrimary = "_2t-1g";
export var iconSecondary = "_2t-1h";
export var iconTertiary = "_2t-1i";
export var integrationCard = "_2t-1";
export var integrationLogoBox = "_2t-2";
export var mainColumnSticky = "_2t-1b";
export var maxWidthContainer = "_2t-19";
export var modalContentBody = "_2t-a";
export var modalHeaderImage = "_2t-5";
export var modalImageLabel = "_2t-7";
export var modalImageOverlay = "_2t-6";
export var modalImageSubtitle = "_2t-9";
export var modalImageTitle = "_2t-8";
export var modalImageWrapper = "_2t-4";
export var modalStickyFooter = "_2t-b";
export var removeButton = "_2t-e";
export var sidebarColumn = "_2t-1a";
export var spinner = "_2t-i";
export var timelineLine = "_2t-y";
export var timelineLineBlack = "_2t-10 _2t-y";
export var timelineLineGray = "_2t-z _2t-y";
export var timelineLineHeight = "_2t-x";
export var tlDotActivate = "_2t-u";
export var tlDotActivateAnim = "_2t-t";
export var tlDotHide = "_2t-s";
export var tlDotHideAnim = "_2t-r";
export var tlLineActivate = "_2t-w";
export var tlLineActivateAnim = "_2t-v";
export var uploadHint = "_2t-n";
export var uploadIconBox = "_2t-k";
export var uploadLabel = "_2t-m";
export var uploadText = "_2t-l";
export var uploadZone = "_2t-f";
export var uploadZoneCursorDefault = "_2t-h";
export var uploadZoneCursorPointer = "_2t-g";
export var uploadedFileRow = "_2t-c";
export var viewButton = "_2t-d";